import type { AxiosInstance } from '@glovo/fetcher'
import type { CityType } from '@/city/entities'
import { CitySchema } from '@/city/entities'
import { getAllCitiesAndCountries } from '@/country'
import type { City } from '@/country/types'
import { getConfig } from '@/tools/config'
import { fetcher as clientFetcher } from '@/tools/fetcher/client'
import type { Language } from '@/tools/i18n'

export const getCityCodeFromCityName = async (
  cityName: string,
  language: Language,
  fetcher: AxiosInstance = clientFetcher
): Promise<string | null> => {
  const { cities } = await getAllCitiesAndCountries(language, fetcher)
  const normalizedUrlCityName = cityName?.toLowerCase()
  const city = cities.find((city) => {
    const normalizedDataCityName = city.name?.toLowerCase()
    return normalizedDataCityName === normalizedUrlCityName
  })

  return city?.code.toUpperCase() || null
}

export const getCityFromCityName = async (
  cityName: string,
  language: Language,
  fetcher: AxiosInstance = clientFetcher
): Promise<City | undefined> => {
  const { cities } = await getAllCitiesAndCountries(language, fetcher)
  const normalizedUrlCityName = cityName?.toLowerCase()
  return cities.find((city) => {
    const normalizedDataCityName = city.name?.toLowerCase()
    return normalizedDataCityName === normalizedUrlCityName
  })
}

export const getCityFromCityCode = async (
  cityCode: string,
  fetcher: AxiosInstance = clientFetcher
): Promise<CityType> => {
  const { apiUrl } = getConfig()
  const response = await fetcher.get(`${apiUrl}/v3/customers/cities?city_code=${cityCode}`)
  return CitySchema.parse(response.data.city)
}
